import { render, staticRenderFns } from "./IconQuote.vue?vue&type=template&id=69c70fce&scoped=true&"
import script from "./IconQuote.vue?vue&type=script&lang=js&"
export * from "./IconQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c70fce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c70fce')) {
      api.createRecord('69c70fce', component.options)
    } else {
      api.reload('69c70fce', component.options)
    }
    module.hot.accept("./IconQuote.vue?vue&type=template&id=69c70fce&scoped=true&", function () {
      api.rerender('69c70fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconQuote.vue"
export default component.exports